import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';
import sagas from './sagas';
import { apiClient } from '../utils';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = { key: 'root', storage, whitelist: ['token', 'session'] };

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose;

let store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
let persistor = persistStore(store);

store.rootTaks = sagaMiddleware.run(sagas, apiClient, store);

export { persistor, store };
